import React from "react";
import { FormProvider } from "react-hook-form";
import { Stack, Typography } from "@mui/material";

import { updateTenantWorkingHours } from "../../../services/apiSystemSettings";
import { useResponsive } from "../../../hooks/useResponsive";
import {
  RFHTextField as RHFTextField,
  RFHToggle as RHFToggle,
} from "../../../components/RFH";
import { CustomButton } from "../../../components/Button/Button";
import { useSimpleSettingsForm } from "./hooks/useSimpleSettingsForm";

function WorkingHours({ initialData }) {
  const { methods, isPending, hasChanges, onSubmit } = useSimpleSettingsForm({
    initialData,
    mutationFn: updateTenantWorkingHours,
    invalidateKeys: ["logo", "tenant-details"],
  });

  const isMobile = useResponsive("down", "md");

  return (
    <>
      <FormProvider {...methods}>
        <div className="mt-32 form-section  ">
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <div>
              <Typography className="setting-heading mb-2  ml-0">
                Working Hours
              </Typography>

              <Stack
                mt={3}
                direction={isMobile ? "column" : "row"}
                spacing={2.5}
              >
                <RHFTextField
                  name="daily_worklog_hours"
                  label="Working Hours Per Day"
                  type="number"
                  className="working-hours-text-field"
                />
              </Stack>
            </div>
            <div className="d-flex mt-32 align-items-center">
              <div className="mr-4">
                <Typography className="setting-heading  ml-0">
                  Remind Users to Enter Worklogs
                </Typography>
                <div className=" ldap-note ">
                  <Typography className="logo-note">
                    When enabled, users will see reminders to enter worklogs.
                  </Typography>
                </div>
              </div>
              <div className="ml-2">
                <RHFToggle name="daily_worklog_reminder" />
              </div>
            </div>
            <Stack alignItems="end" className="mt-32">
              <CustomButton
                variant="contained"
                type="submit"
                className="theme-bg-color working-hours-update-button"
                disabled={isPending || !hasChanges()}
              >
                Update
              </CustomButton>
            </Stack>
          </form>
        </div>
      </FormProvider>
    </>
  );
}

export default React.memo(WorkingHours);
